export default __webpack_public_path__ + "static/media/ADSIL (1920 x 1184).b47e0caa.png";